// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store'
import * as filters from './utils'
import VueAMap from 'vue-amap'  // 4.cnpm下载的高德地图插件
import '../static/css/components.css' // 引入公共样式(修改elementUI默认样式)
import '../static/css/navigation.css' // 引入公共样式(自定义样式)
import '../static/css/newForm.css' // 引入公共样式(表单样式)
import '../static/js/iconfont' // 引入阿里iconfont
import echarts from 'echarts'
// import FORMATJS from './mixin/filter'
// eslint-disable-next-line no-unused-vars
import myMix from './mixin'
import './icons'

// import Print from './plugs/print'
import Print from 'vue-print-nb'
Vue.use(Print) // 注册

Vue.use(ElementUI)

Vue.use(VueAMap)  // 5.使用下载的高德地图插件

// 6.初始化vue-amap
VueAMap.initAMapApiLoader({
  key: 'e542e9d229dc89b014a34ab8569e72f2',
  plugin: [
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多，边形
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.MouseTool',
  ],
  uiVersion: '1.0'
})

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
window.xmlns = 'http://www.w3.org/2000/svg'




/** 本地测试地址 */
// Vue.prototype.url = 'http://192.168.0.186:9078'
// Vue.prototype.url2 = 'http://192.168.0.186:9081'
/** END  */


/** 线上地址 */
Vue.prototype.url = 'http://114.115.166.192:9078'
Vue.prototype.url2 = 'http://114.115.166.192:9077'
/** END  */





Vue.prototype.curVersion = '/api/1.1' // 后台接口版本号
Vue.prototype.curVersion2 = '/api/1.0' // 后台接口版本号
let url = window.location.href
url = url.substr(url.indexOf('://') + 3)
Vue.prototype.domainName = url.substr(0, url.indexOf('/'))
Vue.prototype.apiUrl = Vue.prototype.url + Vue.prototype.curVersion
Vue.prototype.apiUrl2 = Vue.prototype.url2 + Vue.prototype.curVersion2
Vue.prototype.domainName = '114.67.97.220:10009' // 线上

// 注册全局实用程序筛选器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js